<template>
    <UPageCard class="w-full max-w-100">
        <div class="space-y-6">
            <div class="text-center">
                <div class="mb-2">
                    <ULink to="/" class="flex justify-center"><UIcon name="i-custom-logo" class="size-15" /></ULink>
                </div>
                <div v-if="title || !!slots.title" class="text-xl text-pretty font-semibold text-highlighted">
                    <slot name="title">{{ title }}</slot>
                </div>
                <div v-if="description || !!slots.description" class="mt-1 text-base text-pretty text-muted">
                    <slot name="description">{{ description }}</slot>
                </div>
            </div>
            <div class="gap-y-6 flex flex-col">
                <slot />
            </div>
        </div>
        <div v-if="footer || !!slots.footer" class="text-sm text-center text-muted mt-2">
            <slot name="footer">{{ footer }}</slot>
        </div>
    </UPageCard>
</template>

<script setup lang="ts">
    withDefaults(defineProps<{
        title?: string;
        description?: string;
        footer?: string;
    }>(), {
        title: '',
        description: '',
        footer: '',
    });

    const slots = defineSlots<{
        default(): any;
        title?(): any;
        description?(): any;
        footer?(): any;
    }>();
</script>
